const spaceTokens = {
  "field.spacing": 4
};
export { spaceTokens };
//# sourceMappingURL=Field.tokens.mjs.map
